import { render, staticRenderFns } from "./page-share.vue?vue&type=template&id=0a0eedec&"
import script from "./page-share.vue?vue&type=script&lang=js&"
export * from "./page-share.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports